export const skillStringMapping = {
    sport_player_roles_prefix_2: "BOWL",
    sport_player_roles_prefix_4: "WK",
    sport_player_roles_prefix_3: "ALL R",
    sport_player_roles_prefix_1: "BAT",
};

export const skillMapping = (
    skillId: string,
    skillBat: string,
    skillBowl: string,
) => {
    if (skillId === "1" || skillId === "4") {
        return skillBat || "";
    } else if (skillId === "2") {
        return skillBowl || "";
    } else if (skillId === "3") {
        return `${skillBat},${skillBowl}`;
    }
};

export const getBattingStyleAbbreviation = (text: string): string => {
    if (!text) return "";
    // Split by hyphen or whitespace
    const words = text?.split(/[-\s]+/);
    return words?.map((word) => word?.charAt(0).toUpperCase()).join("");
};

export const generateColumns = (columns) => {
    return columns.map((column) => {
        const key = Object.keys(column)[0];

        return {
            accessor: key,

            header: column[key],
        };
    });
};
